export default "__VITE_ASSET__2b1e4c1b__"